import { render, staticRenderFns } from "./EditAccountInformationForm.vue?vue&type=template&id=1d53521d"
import script from "./EditAccountInformationForm.vue?vue&type=script&lang=js"
export * from "./EditAccountInformationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports